/* nebe — magazínový článek v Rádci
   Kalkulačka velikosti, dlaždice produktů s reálným košíkem, hotspot ve fotce,
   náhled u tabulky modelů a ručně kreslený scribble.
   Vše scope-ované na kořen sekce, ať jde sekce vložit i vícekrát. */
(function () {
  var productCache = {};

  // Stoq (Restock Rocket): openModal(produkt, variantId) — zjištěno z app embedu.
  // Bez appky padáme na produktovku s předvybranou variantou.
  function openWatchForm(handle, variantId) {
    var fallback = function () { window.location = '/products/' + handle + '?variant=' + variantId; };
    var api = window._Stoq || window._RestockRocket;
    if (!api || typeof api.openModal !== 'function') return fallback();
    var open = function (product) {
      try { api.openModal(product, Number(variantId)); } catch (e) { fallback(); }
    };
    if (productCache[handle]) return open(productCache[handle]);
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { productCache[handle] = p; open(p); })
      .catch(fallback);
  }

  function init(root) {
    if (root.dataset.ncReady === '1') return;
    root.dataset.ncReady = '1';

    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- kolik místa si bere lepivá hlavička motivu ----------
       Bez toho se sticky dlaždice v postranním sloupci schová pod hlavičku,
       která vyjede při scrollu nahoru. Motiv žádnou proměnnou s výškou nemá. */
    var hdr = document.querySelector('.section-header .header') || document.querySelector('.header');
    var setHdr = function () {
      var h = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
      root.style.setProperty('--nc-header', (h > 0 ? h : 72) + 'px');
    };
    setHdr();
    addEventListener('resize', setHdr, { passive: true });

    var T = {};
    var i18nEl = root.querySelector('[data-nc-i18n]');
    if (i18nEl) { try { T = JSON.parse(i18nEl.textContent); } catch (e) { T = {}; } }

    /* ---------- dlaždice produktu: barva → velikosti → košík ---------- */
    function dlazdice(card) {
      var bar = card.querySelector('.nc-best__colors');
      var vel = card.querySelector('.nc-best__sizes');
      var form = card.querySelector('form[data-nc-form]');
      if (!vel || !form) return;

      var add = form.querySelector('[data-nc-add]');
      var idInput = form.querySelector('input[name="id"]');
      var note = card.querySelector('[data-nc-note]');
      var foto = card.querySelector('.nc-best__media img, .nc-hs__media img');
      var priceEl = card.querySelector('.nc-best__price');
      var handle = card.dataset.ncHandle;
      var data = null;
      var dataEl = card.querySelector('[data-nc-colors]');
      if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; } }

      var L = {
        pick: add.dataset.lPick,
        add: add.dataset.lAdd,
        done: add.dataset.lDone,
        watch: add.dataset.lWatch,
        watchHint: add.dataset.lWatchHint,
        noColor: add.dataset.lNoColor
      };
      var noteTimer = null;
      function say(msg, warn) {
        if (!note) return;
        clearTimeout(noteTimer);
        note.textContent = msg || '';
        note.classList.toggle('nc-is-warn', !!warn);
        if (msg) noteTimer = setTimeout(function () { note.textContent = ''; note.classList.remove('nc-is-warn'); }, 3600);
      }

      var watchId = null;
      function setAdd(state, size) {
        if (state === 'pick') {
          add.disabled = true; add.textContent = L.pick; watchId = null; idInput.value = '';
        } else if (state === 'add') {
          add.disabled = false; add.textContent = L.add; watchId = null;
        } else if (state === 'watch') {
          add.disabled = false; add.textContent = L.watch; watchId = size;
          idInput.value = '';
          say(L.watchHint, false);
        }
      }

      // barva řídí dostupnost velikostí, fotku i cenu
      function zvol(key) {
        var c = data && data[key];
        if (!c) return;
        if (bar) {
          bar.querySelectorAll('button').forEach(function (x) {
            x.setAttribute('aria-pressed', String(x.dataset.ncColor === key));
          });
        }
        vel.querySelectorAll('button').forEach(function (t) {
          var v = c.sizes[t.dataset.s];
          t.classList.remove('nc-low', 'nc-out');
          t.setAttribute('aria-pressed', 'false');
          if (!v) {                       // tuhle velikost v téhle barvě vůbec neděláme
            t.disabled = true; t.title = L.noColor || '';
          } else if (!v.av) {             // děláme, ale došla
            t.disabled = false; t.classList.add('nc-out'); t.title = '';
          } else {
            t.disabled = false; t.title = '';
            if (v.low) t.classList.add('nc-low');
          }
        });
        if (foto && c.img && foto.getAttribute('src') !== c.img) {
          foto.src = c.img;
          if (c.alt) foto.alt = c.alt;
          if (c.fp) foto.style.objectPosition = c.fp;
        }
        if (priceEl && c.price) priceEl.textContent = c.price;
        card.dataset.ncColor = key;
        setAdd('pick');
        say('');
      }

      if (bar) {
        bar.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () { zvol(b.dataset.ncColor); });
        });
      }

      vel.querySelectorAll('button').forEach(function (t) {
        t.addEventListener('click', function () {
          if (t.disabled) return;
          vel.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          t.setAttribute('aria-pressed', 'true');
          var c = data && data[card.dataset.ncColor];
          var v = c && c.sizes[t.dataset.s];
          if (!v) return;
          if (v.av) { idInput.value = v.id; setAdd('add'); say(''); }
          else { setAdd('watch', v.id); }
        });
      });

      form.addEventListener('submit', function (ev) {
        if (watchId) { ev.preventDefault(); openWatchForm(handle, watchId); return; }
        if (!idInput.value) { ev.preventDefault(); return; }
        if (!window.fetch) return;        // bez fetch necháme projít klasický submit

        ev.preventDefault();
        add.disabled = true;

        var drawer = document.querySelector('mini-cart')
          || document.querySelector('cart-drawer')
          || document.querySelector('cart-notification');

        var fd = new FormData(form);
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          fd.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }));
          fd.append('sections_url', window.location.pathname);
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
        }

        var addUrl = '/cart/add.js';
        try {
          if (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url) addUrl = theme.routes.cart_add_url;
        } catch (e) {}

        fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) { say(response.description || response.message || '', true); return; }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'nebe-clanek', productVariantId: fd.get('id'), cart: response
                });
              } catch (e) {}
            }
            add.textContent = L.done;
            setTimeout(function () { if (!add.disabled) add.textContent = L.add; }, 2200);
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(response);
            } else {
              window.location = '/cart';
            }
          })
          .catch(function () { form.submit(); })
          .finally(function () { add.disabled = false; });
      });

      zvol(card.dataset.ncColor);
    }
    root.querySelectorAll('[data-nc-tile]').forEach(dlazdice);

    /* ---------- hotspot ve fotce ---------- */
    root.querySelectorAll('.nc-dot').forEach(function (d) {
      d.addEventListener('click', function (e) {
        e.stopPropagation();
        var box = root.querySelector('#' + d.getAttribute('aria-controls'));
        if (!box) return;
        var open = d.getAttribute('aria-expanded') === 'true';
        d.setAttribute('aria-expanded', String(!open));
        box.hidden = open;
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.nc-hs') || e.target.closest('.nc-dot')) return;
      root.querySelectorAll('.nc-dot[aria-expanded="true"]').forEach(function (d) {
        d.setAttribute('aria-expanded', 'false');
        var box = root.querySelector('#' + d.getAttribute('aria-controls'));
        if (box) box.hidden = true;
      });
    });

    /* ---------- náhled produktu při najetí na jeho jméno (desktop) ----------
       Nevěší se jen na tabulku modelů: projde všechny odkazy na produkt v textu
       včetně těch, které do výsledku kalkulačky dopíše JS. Box je position:fixed,
       aby ho neořízl vodorovný scroll tabulky. */
    var navazPeek = function () {};
    var peeks = root.querySelector('[data-nc-peeks]');
    if (peeks) {
      var siroko = matchMedia('(min-width:941px)'), cas = null, ted = null;

      var umisti = function (pop, trig) {
        var t = trig.getBoundingClientRect();
        var w = pop.offsetWidth, h = pop.offsetHeight;
        var x = Math.min(Math.max(8, t.left), innerWidth - w - 8);
        var y = t.bottom + 8;
        // pod odkaz; kdyby vytekl pod okno, vyjede nad něj
        if (y + h > innerHeight - 8 && t.top - 8 - h > 0) y = t.top - h - 8;
        pop.style.left = x + 'px';
        pop.style.top = y + 'px';
      };
      var zavri = function () { if (ted) { ted.classList.remove('nc-is-on'); ted = null; } };
      var odloz = function () { clearTimeout(cas); cas = setTimeout(zavri, 400); };
      var otevri = function (trig) {
        if (!siroko.matches) return;
        var pop = root.querySelector('#' + trig.dataset.peek);
        if (!pop) return;
        clearTimeout(cas);
        if (ted && ted !== pop) ted.classList.remove('nc-is-on');
        umisti(pop, trig);
        pop.classList.add('nc-is-on');
        ted = pop;
      };

      var navaz = function (a) {
        if (a.dataset.peekBound) return;
        a.dataset.peekBound = '1';
        a.addEventListener('mouseenter', function () { otevri(a); });
        a.addEventListener('focus', function () { otevri(a); });
        a.addEventListener('mouseleave', odloz);
        a.addEventListener('blur', odloz);
      };

      navazPeek = function () {
        root.querySelectorAll('[data-peek]').forEach(navaz);
        root.querySelectorAll('.nc-main a[href*="/products/"]').forEach(function (a) {
          // dlaždice a produktové karty mají vlastní chování, ty vynecháme
          if (a.closest('[data-nc-tile]') || a.closest('.nc-pick') || a.closest('.nc-dal__list')) return;
          var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
          if (!m) return;
          var id = 'nc-peek-' + m[1];
          if (!root.querySelector('#' + id)) return;
          a.dataset.peek = id;
          navaz(a);
        });
      };
      navazPeek();

      root.querySelectorAll('.nc-peek').forEach(function (pop) {
        pop.addEventListener('mouseenter', function () { clearTimeout(cas); });
        pop.addEventListener('focusin', function () { clearTimeout(cas); });
        pop.addEventListener('mouseleave', odloz);
        pop.addEventListener('focusout', odloz);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { clearTimeout(cas); zavri(); } });
      siroko.addEventListener('change', function () { if (!siroko.matches) { clearTimeout(cas); zavri(); } });
      // box je fixed, při scrollu by jinak zůstal viset u prázdného místa
      addEventListener('scroll', function () { if (ted) { clearTimeout(cas); zavri(); } }, { passive: true });
    }

    /* ---------- scribble ---------- */
    var P = 'M-335,54 C-335,54 -171,-58 -194,-3 C-217,52 -224.12,73.552 -127,11 C-68,-27 -137,50 -33,42 C31.439,37.043 147.147,-29.308 335,2';
    root.querySelectorAll('[data-hl]').forEach(function (el) {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('viewBox', '-350 -60 700 140');
      s.setAttribute('preserveAspectRatio', 'none');
      s.setAttribute('aria-hidden', 'true');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', P); p.setAttribute('stroke-linecap', 'round');
      s.appendChild(p); el.insertBefore(s, el.firstChild);
      var len = p.getTotalLength();
      p.style.strokeDasharray = len; p.style.strokeDashoffset = len;
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('nc-is-drawn'); io.unobserve(e.target); }
        });
      }, { threshold: 0.9 });
      root.querySelectorAll('[data-hl]').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('[data-hl]').forEach(function (el) { el.classList.add('nc-is-drawn'); });
    }

    /* ---------- výběr velikosti ----------
       Hlavní cesta: konfekční velikost ze dvou selectů. Číslo samo určuje naši
       velikost (65 = XS … 90 = XXL), košíček jen rozhoduje, jestli tu kombinaci
       šijeme. Měření je záložní cesta a jen vyplní tytéž selecty. */
    var band = root.querySelector('[data-nc-band]');
    var cup = root.querySelector('[data-nc-cup]');
    var res = root.querySelector('[data-nc-res]');
    if (band && cup && res) (function () {

    var known = root.querySelector('[data-nc-known]');
    var measure = root.querySelector('[data-nc-measure]');

    // z převodní tabulky (jediný zdroj pravdy, sdílený s tabulkou v článku)
    var MAP = T.sizeMap || {};
    var KOD = {};           // '75B' → 'M'
    var CUPS_BY_BAND = {};  // '75' → ['A','B','C','D']
    Object.keys(MAP).forEach(function (v) {
      MAP[v].forEach(function (kod) {
        KOD[kod] = v;
        var b = kod.match(/^\d+/)[0];
        (CUPS_BY_BAND[b] = CUPS_BY_BAND[b] || []).push(kod.slice(b.length));
      });
    });

    function vypis(html, cls) {
      res.className = 'nc-res' + (cls ? ' ' + cls : '');
      res.innerHTML = html;
      void res.offsetHeight;            // reflow, jinak se přechod z display:none nespustí
      res.classList.add('nc-is-on');
      navazPeek();                      // ve výsledku bývají odkazy na modely
    }
    function schovej() { res.classList.remove('nc-is-on'); res.innerHTML = ''; }

    function vyhodnot() {
      var b = band.value, c = cup.value;
      if (!b || !c) return schovej();
      var kod = b + c;
      var velikost = KOD[kod];
      if (velikost) {
        return vypis('<p class="nc-res__v">' + velikost + '</p>'
          + '<p class="nc-res__k">' + (T.resOk || '').replace('[kod]', kod) + '</p>');
      }
      if (!CUPS_BY_BAND[b]) {           // číslo mimo rozsah, který šijeme
        return vypis('<p class="nc-res__v">' + (T.errBandT || '') + '</p>'
          + '<p class="nc-res__w">' + (T.errBandSelD || '').replace('[band]', b) + '</p>', 'nc-res--no');
      }
      var hint = (T.noHint || '').replace('[band]', b).replace('[cups]', CUPS_BY_BAND[b].join(', '));
      return vypis('<p class="nc-res__v">' + kod + '</p>'
        + '<p class="nc-res__k">' + (T.resNo || '').replace('[kod]', kod) + ' ' + hint + '</p>', 'nc-res--no');
    }
    band.addEventListener('change', vyhodnot);
    cup.addEventListener('change', vyhodnot);

    /* ---------- záložní cesta: měření ---------- */
    var prepni = function (naMereni) {
      if (known) known.hidden = naMereni;
      if (measure) measure.hidden = !naMereni;
    };
    var tgl = root.querySelector('[data-nc-toggle]');
    var tglBack = root.querySelector('[data-nc-toggle-back]');
    if (tgl) tgl.addEventListener('click', function () {
      schovej(); prepni(true);
      var pole = root.querySelector('[data-nc-under]');
      if (pole) pole.focus();
    });
    if (tglBack) tglBack.addEventListener('click', function () { prepni(false); });

    var f = root.querySelector('[data-nc-calc]');
    if (!f) return;
    var u = f.querySelector('[data-nc-under]');
    var o = f.querySelector('[data-nc-over]');
    var go = f.querySelector('[data-nc-go]');

    // Hranice košíčků musí sedět s tabulkou `cup_diff` / `cup_letter` v sekci.
    var BANDS = [[63, 67, 65], [68, 72, 70], [73, 77, 75], [78, 82, 80], [83, 87, 85], [88, 92, 90]];
    var CUPS = [[10, 12, 'A'], [13, 15, 'B'], [16, 17, 'C'], [18, 20, 'D'], [21, 22, 'DD'], [23, 24, 'E'], [25, 26, 'F']];
    function naBand(v) { for (var i = 0; i < BANDS.length; i++) { if (v >= BANDS[i][0] && v <= BANDS[i][1]) return BANDS[i][2]; } return null; }
    function naCup(d) { for (var i = 0; i < CUPS.length; i++) { if (d >= CUPS[i][0] && d <= CUPS[i][1]) return CUPS[i][2]; } return null; }

    function chk() { go.disabled = !(u.value && o.value); }
    u.addEventListener('input', chk);
    o.addEventListener('input', chk);

    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var uv = parseFloat(u.value), ov = parseFloat(o.value);
      if (!uv || !ov) return;

      function stop(nadpis, text) {
        vypis('<p class="nc-res__v">' + nadpis + '</p><p class="nc-res__w">' + text + '</p>', 'nc-res--no');
      }

      var d = Math.round(ov - uv);
      if (ov <= uv) return stop(T.errSwapT, T.errSwapD);
      if (d < 10) return stop(T.errSmallT, (T.errSmallD || '').replace('[d]', d));
      if (d > 26) return stop(T.errBigT, (T.errBigD || '').replace('[d]', d));
      var b = naBand(uv);
      if (!b) return stop(T.errBandT, (T.errBandD || '').replace('[u]', uv));

      // měření jen vyplní selecty — čtenářka pak vidí, co jí vyšlo konfekčně
      band.value = String(b);
      cup.value = naCup(d);
      prepni(false);
      vyhodnot();
    });
    })();

    /* ---------- volič: vyber situaci, dostaneš odpověď ----------
       Obecný, data si každý článek nese ve vlastním JSON bloku. */
    root.querySelectorAll('[data-nc-volic]').forEach(function (vol) {
      var out = vol.querySelector('[data-nc-vres]');
      var opts = vol.querySelector('.nc-opts');
      var znovu = vol.querySelector('[data-nc-znovu]');
      var dataEl = vol.querySelector('[data-nc-volic-data]');
      if (!out || !opts || !dataEl) return;
      var D = {};
      try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var radios = [].slice.call(vol.querySelectorAll('input[type="radio"]'));

      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          var d = D[r.value];
          if (!d) return;
          opts.classList.add('nc-is-off');
          if (znovu) znovu.hidden = false;
          out.className = 'nc-res nc-res--pick';
          out.innerHTML = (d.l ? '<p class="nc-res__lbl">' + d.l + '</p>' : '')
            + '<p class="nc-res__v">' + d.p + '</p>'
            + (d.w ? '<p class="nc-res__k">' + d.w + '</p>' : '')
            + (d.n ? '<p class="nc-res__w">' + d.n + '</p>' : '');
          void out.offsetHeight;
          out.classList.add('nc-is-on');
          navazPeek();
        });
      });

      if (znovu) znovu.addEventListener('click', function () {
        opts.classList.remove('nc-is-off');
        out.className = 'nc-res';
        out.innerHTML = '';
        znovu.hidden = true;
        radios.forEach(function (r) { r.checked = false; });
        if (radios[0]) radios[0].focus();
      });
    });

    /* ---------- jeden rozměr → velikost ---------- */
    var rz = root.querySelector('[data-nc-rozmer]');
    if (rz) {
      var rOut = root.querySelector('[data-nc-rres]');
      var rZnovu = root.querySelector('[data-nc-rznovu]');
      var rVal = rz.querySelector('[data-nc-val]');
      var rGo = rz.querySelector('[data-nc-rgo]');
      var rD = {};
      var rDataEl = root.querySelector('[data-nc-rozmer-data]');
      try { rD = JSON.parse(rDataEl.textContent); } catch (e) { rD = {}; }
      var PASMA = rD.ranges || [];

      var rVypis = function (html, cls) {
        rz.classList.add('nc-is-off');
        if (rZnovu) rZnovu.hidden = false;
        rOut.className = 'nc-res nc-res--pick' + (cls ? ' ' + cls : '');
        rOut.innerHTML = html;
        void rOut.offsetHeight;
        rOut.classList.add('nc-is-on');
        navazPeek();
      };

      rVal.addEventListener('input', function () { rGo.disabled = !rVal.value; });
      if (rZnovu) rZnovu.addEventListener('click', function () {
        rz.classList.remove('nc-is-off');
        rOut.className = 'nc-res';
        rOut.innerHTML = '';
        rZnovu.hidden = true;
        rVal.value = '';
        rGo.disabled = true;
        rVal.focus();
      });

      rz.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = parseFloat(rVal.value);
        if (!v) return;
        var hit = null, kraj = false, posledni = false;
        for (var i = 0; i < PASMA.length; i++) {
          if (v >= PASMA[i][0] && v <= PASMA[i][1]) {
            hit = PASMA[i][2];
            kraj = v >= PASMA[i][1] - 1;      // na horní hranici radši o velikost víc
            posledni = i === PASMA.length - 1;
            break;
          }
        }
        if (!hit) {
          return rVypis('<p class="nc-res__lbl">' + (rD.lblNo || '') + '</p>'
            + '<p class="nc-res__v">' + (rD.outT || '') + '</p>'
            + '<p class="nc-res__w">' + (rD.outD || '').replace('[v]', v) + '</p>', 'nc-res--no');
        }
        var klic = kraj ? (posledni ? 'top' : 'edge') : 'ok';
        rVypis('<p class="nc-res__lbl">' + (rD.lbl || '') + '</p>'
          + '<p class="nc-res__v">' + hit + '</p>'
          + '<p class="nc-res__k">' + (rD[klic + 'K'] || '').replace('[s]', hit).replace('[v]', v) + '</p>'
          + '<p class="nc-res__w">' + (rD[klic + 'W'] || '').replace('[s]', hit).replace('[v]', v) + '</p>');
      });
    }
  }

  var boot = function () { document.querySelectorAll('[data-nebe-clanek]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
